import Actions from "../NipTypes";

const initialState = {
    isGettingKit: false,
    getKitSuccess: false,
    nipKit: {},
    isDownloadingKit: false,
    downloadaSuccess: false,
    kitFile: {},
    isGettingAllNipApplications: false,
    getNipApplicationsSuccess: false,
    nipApplications: [],
    isGettingSingleNipApplication: false,
    getNipApplicationSuccess: false,
    nipApplication: [],
    isSubmittingApplication: false,
    submitApplicationSuccess: false,
    submitApplication: [],
    isSubmittingRequest: false,
    submitRequestSuccess: false,
    isSubmittingRequestForm: false,
    submitRequestFormSuccess: false,
    isUploadingKey: false,
    uploadSuccess: false,
    key: {},
    error: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Actions.GET_NIP_KIT_START:
            return {
                ...state,
                isGettingKit: true,
                getKitSuccess: false,
                error: null,
            };
        case Actions.GET_NIP_KIT_SUCCESS:
            return {
                ...state,
                isGettingKit: false,
                getKitSuccess: true,
                nipKit: action.payload,
                error: null,
            };
        case Actions.GET_NIP_KIT_FAILURE:
            return {
                ...state,
                isGettingKit: false,
                getKitSuccess: false,
                error: action.payload,
            };
        case Actions.DOWNLOAD_NIP_KIT_START:
            return {
                ...state,
                isDownloadingKit: true,
                downloadSuccess: false,
                error: null,
            };
        case Actions.DOWNLOAD_NIP_KIT_SUCCESS:
            return {
                ...state,
                isDownloadingKit: false,
                downloadSuccess: true,
                kitFile: action.payload,
            };
        case Actions.DOWNLOAD_NIP_KIT_FAILURE:
            return {
                ...state,
                isDownloadingKit: false,
                downloadSuccess: false,
                error: action.payload,
            };
        case Actions.GET_ALL_NIP_APPLICATIONS_START:
            return {
                ...state,
                isGettingAllNipApplications: true,
                getNipApplicationsSuccess: false,
                error: null,
            };
        case Actions.GET_ALL_NIP_APPLICATIONS_SUCCESS:
            return {
                ...state,
                isGettingAllNipApplications: false,
                getNipApplicationsSuccess: true,
                nipApplications: action.payload,
                error: null,
            };
        case Actions.GET_ALL_NIP_APPLICATIONS_FAILURE:
            return {
                ...state,
                isGettingSingleNipApplication: false,
                getNipApplicationSuccess: false,
                error: action.payload,
            };
        case Actions.GET_SINGLE_NIP_APPLICATION_START:
            return {
                ...state,
                isGettingSingleNipApplication: true,
                getNipApplicationSuccess: false,
                error: null,
            };
        case Actions.GET_SINGLE_NIP_APPLICATION_SUCCESS:
            return {
                ...state,
                isGettingSingleNipApplication: false,
                getNipApplicationSuccess: true,
                nipApplication: action.payload,
                error: null,
            };
        case Actions.GET_SINGLE_NIP_APPLICATION_FAILURE:
            return {
                ...state,
                isGettingSingleNipApplication: false,
                getNipApplicationSuccess: false,
                error: action.payload,
            };
        case Actions.SUBMIT_NIP_APPLICATION_START:
            return {
                ...state,
                isSubmittingApplication: true,
                submitApplicationSuccess: false,
                error: null,
            };
        case Actions.SUBMIT_NIP_APPLICATION_SUCCESS:
            return {
                ...state,
                isSubmittingApplication: false,
                submitApplicationSuccess: true,
                submitApplication: action.payload,
                error: null,
            };
        case Actions.SUBMIT_NIP_APPLICATION_FAILURE:
            return {
                ...state,
                isSubmittingApplication: false,
                submitApplicationSuccess: false,
                error: action.payload,
            };
        case Actions.SUBMIT_REQUEST_FOR_PERMIT_START:
            return {
                ...state,
                isSubmittingRequest: true,
                submitRequestSuccess: false,
                error: null,
            };
        case Actions.SUBMIT_REQUEST_FOR_PERMIT_SUCCESS:
            return {
                ...state,
                isSubmittingRequest: false,
                submitRequestSuccess: true,
            };
        case Actions.SUBMIT_REQUEST_FOR_PERMIT_FAILURE:
            return {
                ...state,
                isSubmittingRequest: false,
                submitRequestSuccess: false,
                error: action.payload,
            };
        case Actions.SUBMIT_REQUEST_FORM_START:
            return {
                ...state,
                isSubmittingRequestForm: true,
                submitRequestFormSuccess: false,
                error: null,
            };
        case Actions.SUBMIT_REQUEST_FORM_SUCCESS:
            return {
                ...state,
                isSubmittingRequestForm: false,
                submitRequestFormSuccess: true,
            };
        case Actions.SUBMIT_REQUEST_FORM_FAILURE:
            return {
                ...state,
                isSubmittingRequestForm: false,
                submitRequestFormSuccess: false,
                error: action.payload,
            };
        case Actions.UPLOAD_KEY_START:
            return {
                ...state,
                isUploadingKey: true,
                uploadSuccess: false,
                error: null,
            };
        case Actions.UPLOAD_KEY_SUCCESS:
            return {
                ...state,
                isUploadingKey: false,
                key: action.payload,
                uploadSuccess: true,
            };
        case Actions.UPLOAD_KEY_FAILURE:
            return {
                ...state,
                isUploadingKey: false,
                uploadSuccess: false,
                error: action.payload,
            };
        case Actions.CLEAR_NIP_STATE:
            return initialState;
        default:
            return state;
    }
};
